'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import {
  matchRoute,
  studentRoutes,
} from '@mildang/design-system/type-routes';
import { activityManager } from '@ui/utils/ActivityManager';
import { useEffect, useRef } from 'react';
import { B2CUrlPathMap } from '@ui/utils/getParsedViewParams';

import isSSR from 'utils/isSSR';

// student-web, app router에서 사용하는 hook
function useStudentWebNavChangeApp() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const urlRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (isSSR) {
      return;
    }

    // Convert searchParams to query object like page router
    const query: Record<string, string | string[]> = {};
    searchParams.forEach((value, key) => {
      query[key] = value;
    });

    // Build full path with search params
    const path = pathname + (searchParams.toString() ? `?${searchParams.toString()}` : '');
    const url = path;

    function onRouteChange() {
      const pathGroup = B2CUrlPathMap[pathname];

      let newQuery = { ...query };

      if (pathGroup === 'learning') {
        const urlObj = new URL(url, window.location.origin);
        const pathParts = urlObj.pathname.split('/').filter(Boolean);
        newQuery = {
          ...query,
          //  @ts-ignore
          unitId: pathParts[2] || newQuery?.unitId,
        };
      }

      const matchedRoute = matchRoute(studentRoutes, url);

      activityManager.startNewView({
        host: window.location.host,
        pathname: matchedRoute?.template ?? '',
        path: url,
        query: {
          ...(matchedRoute?.pathParams ?? {}),
          ...(matchedRoute?.queryParams ?? {}),
        },
      });
    }

    // 페이지 이동 시에만 호출
    if (urlRef.current && urlRef.current !== url) {
      onRouteChange();
    }
    urlRef.current = url;


  }, [pathname, searchParams]);
}

export default useStudentWebNavChangeApp;
